<template>
  <div>
    <ht-company-sidebar></ht-company-sidebar>

    <div class="pt-4" v-if="$can('view-company-dashboard')">
      <div class="vx-row">
        <div class="vx-col w-full md:w-2/3 mb-base">
          <vx-card title="Maandelijkse omzet">
            <template slot="actions">
              <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <div class="flex">
                <div class="mr-6">
                  <p class="mb-1 font-semibold">Deze Maand</p>
                  <p
                    class="text-3xl"
                    :class="{'text-danger': lastMonth > thisMonth, 'text-success': thisMonth > lastMonth}"
                  >
                    <sup class="text-base mr-1">€</sup>
                    {{ thisMonth }}
                  </p>
                </div>
                <div>
                  <p class="mb-1 font-semibold">Vorige Maand</p>
                  <p class="text-3xl">
                    <sup class="text-base mr-1">€</sup>
                    {{ lastMonth }}
                  </p>
                </div>
              </div>
              <vue-apex-charts
                v-if="renderMonthlyChart"
                type="line"
                height="266"
                :series="monthlyRevenueChartLine.series"
                :options="monthlyRevenueChartLine.options"
              />
            </div>
            <small><em>De hierboven vermelden bedragen zijn inclusief Hebtrek kosten.</em></small>
          </vx-card>
        </div>
        <div class="vx-col w-full md:w-1/3 mb-base">
          <vx-card title="Top 10 producten">
            <vs-list>
              <vs-list-item v-for="(item, index) in popularProducts" :key="item.id" :title="(index + 1).toString() + ' ' + item.name"> </vs-list-item>
            </vs-list>
          </vx-card>
        </div>
        <div class="vx-col w-full md:w-2/3 mb-base">
          <vx-card title="Weekelijkse omzet">
            <template slot="actions">
              <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <div class="flex">
                <div class="mr-6">
                  <p class="mb-1 font-semibold">Deze Week</p>
                  <p
                    class="text-3xl"
                    :class="{'text-danger': lastWeek > thisWeek, 'text-success': thisWeek > lastWeek}"
                  >
                    <sup class="text-base mr-1">€</sup>
                    {{ thisWeek }}
                  </p>
                </div>
                <div>
                  <p class="mb-1 font-semibold">Vorige Week</p>
                  <p class="text-3xl">
                    <sup class="text-base mr-1">€</sup>
                    {{ lastWeek }}
                  </p>
                </div>
              </div>
              <vue-apex-charts
                v-if="renderWeeklyChart"
                type="line"
                height="266"
                :series="weeklyRevenueChartLine.series"
                :options="weeklyRevenueChartLine.options"
              />
            </div>
            <small><em>De hierboven vermelden bedragen zijn inclusief Hebtrek kosten.</em></small>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import htCompanySidebar from "./sidebar";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: {
    htCompanySidebar,
    StatisticsCardLine,
    VueApexCharts,
  },
  mounted() {
    this.$vs.loading();
    this.getMonthlyRevenue(null);
    this.getWeeklyRevenue(null);
    this.getOrdersData(null);
    this.getPopularProducts(null);
    this.$events.listen("company-selected", event => {
      this.$vs.loading();
      this.getMonthlyRevenue(event);
      this.getWeeklyRevenue(event);
      this.getOrdersData(event);
      this.getPopularProducts(event);
    });
  },
  data() {
    return {
      thisMonth: 0,
      lastMonth: 0,
      thisWeek: 0,
      lastWeek: 0,
      orderTotal: 0,
      renderMonthlyChart: false,
      renderWeeklyChart: false,
      renderOrderChart: false,
      popularProducts: null,
      timelineData: [
        {
          color: "primary",
          icon: "PlusIcon",
          title: "New Task Added",
          desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
          time: "25 Days Ago",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Task Update Found",
          desc: "Cupcake gummi bears soufflé caramels candy",
          time: "15 Days Ago",
        },
        {
          color: "success",
          icon: "CheckIcon",
          title: "Task Finished",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 mins ago",
        },
      ],
      ordersChart: [
        {
          name: "Bestellingen",
          data: [],
        },
      ],
      weeklyRevenueChartLine: {
        series: [[], []],
        options: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 5,
              left: 0,
              blur: 4,
              opacity: 0.1,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [4, 2],
          },
          grid: {
            borderColor: "#e7e7e7",
          },
          legend: {
            show: false,
          },
          colors: ["#F97794", "#b8c2cc"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: ["#7367F0", "#b8c2cc"],
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              tops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            categories: ["01", "05", "09", "13", "17", "21", "26", "31"],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter(val) {
                return val > 999 ? `${(val / 1000).toFixed(1)}k` : val;
              },
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
      monthlyRevenueChartLine: {
        series: [[], []],
        options: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 5,
              left: 0,
              blur: 4,
              opacity: 0.1,
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [4, 2],
          },
          grid: {
            borderColor: "#e7e7e7",
          },
          legend: {
            show: false,
          },
          colors: ["#F97794", "#b8c2cc"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: ["#7367F0", "#b8c2cc"],
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              tops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
            },
            axisTicks: {
              show: false,
            },
            categories: ["01", "05", "09", "13", "17", "21", "26", "31"],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter(val) {
                return val > 999 ? `${(val / 1000).toFixed(1)}k` : val;
              },
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
    };
  },
  computed: {
    staffRoute() {
      if (this.$route.meta.staff) {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
      } else {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
        return false;
      }
    },
  },
  methods: {
    getMonthlyRevenue: function (company) {
      this.renderMonthlyChart = false;
      if(company !== null) {
        var url = "/v1/company/" + company.slug + "/statistics/monthly/revenue"
      } else {
        var url = "/v1/company/" + this.$route.params.slug + "/statistics/monthly/revenue"
      }
      this.$http.get(url)
        .then((response) => {
          console.log(response.data.data);
          this.thisMonth = response.data.data[1].data[0].toFixed(2);
          this.lastMonth = response.data.data[0].data[0].toFixed(2);
          this.monthlyRevenueChartLine.options.xaxis.categories = response.data.data[0].categories;
          this.monthlyRevenueChartLine.series[0] = {
            name: response.data.data[1].name,
            data: [],
          };
          this.monthlyRevenueChartLine.series[1] = {
            name: response.data.data[0].name,
            data: [],
          };
          response.data.data[1].stops.map((stop) => {
            this.monthlyRevenueChartLine.series[0].data.push(stop.data.toFixed(2));
          });
          response.data.data[0].stops.map((stop) => {
            this.monthlyRevenueChartLine.series[1].data.push(stop.data.toFixed(2));
          });
          this.renderMonthlyChart = true;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    getWeeklyRevenue: function (company) {
      this.renderWeeklyChart = false;
      if(company !== null) {
        var url = "/v1/company/" + company.slug + "/statistics/weekly/revenue"
      } else {
        var url = "/v1/company/" + this.$route.params.slug + "/statistics/weekly/revenue"
      }
      this.$http.get(url)
        .then((response) => {
          console.log(response.data.data);
          this.thisWeek = response.data.data[1].data[0].toFixed(2);
          this.lastWeek = response.data.data[0].data[0].toFixed(2);
          this.weeklyRevenueChartLine.options.xaxis.categories = response.data.data[0].categories;
          this.weeklyRevenueChartLine.series[0] = {
            name: response.data.data[1].name,
            data: [],
          };
          this.weeklyRevenueChartLine.series[1] = {
            name: response.data.data[0].name,
            data: [],
          };
          response.data.data[1].stops.map((stop) => {
            this.weeklyRevenueChartLine.series[0].data.push(stop.data.toFixed(2));
          });
          response.data.data[0].stops.map((stop) => {
            this.weeklyRevenueChartLine.series[1].data.push(stop.data.toFixed(2));
          });
          this.renderWeeklyChart = true;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
          this.$vs.loading.close();
        });
    },
    getOrdersData: function (company) {
      if(company !== null) {
        var url = "/v1/company/" + company.slug + "/statistics/weekly/orders"
      } else {
        var url = "/v1/company/" + this.$route.params.slug + "/statistics/weekly/orders"
      }
      this.$http.get(url)
        .then((response) => {
          response.data.data.map((item) => {
            this.ordersChart[0].data.push(item.data);
            this.orderTotal = this.orderTotal + item.data;
          });
          this.renderOrderChart = true;
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
          this.$vs.loading.close();
        });
    },
    getPopularProducts: function (company) {
      if(company !== null) {
        var url = "/v1/company/" + company.slug + "/statistics/popular-products"
      } else {
        var url = "/v1/company/" + this.$route.params.slug + "/statistics/popular-products"
      }
      this.$http.get(url)
        .then((response) => {
          this.popularProducts = response.data;
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style>
</style>
